export const menuTitle = { title: "SMP", label: "SMP" }
  